/* eslint-disable */
export default {
  title: 'Verlauf',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
